<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1050px'>
    <el-form :model='form' label-width='180px' label-position='right' :rules='rules'
             ref='ruleForm' class='elForm p10'>
      <el-row :gutter='10'>
        <el-col :span='12'>
          <el-form-item label='质损编号：'>
            <span>{{ form.number }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发运日期：'>
            <span>{{ form.massLossTime |dateFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='邮件报备日期：'>
            <span>{{ form.reportingDate |dateFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='品牌：'>
            <span>{{ form.brand }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='车型：'>
            <span>{{ form.model }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='车架号：'>
            <span>{{ form.frameNumber }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='出发地：'>
            <span>{{ form.startAddress }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='目的地：'>
            <span>{{ form.endAddress }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='运输方式：' prop='taskMode'>
            <el-select v-model='form.taskMode' size='mini' filterable style='width:100%'
                       placeholder='请选择运输方式' value-key='id'>
              <el-option label='公路' :value='0' />
              <el-option label='水路' :value='1' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='供应商：' prop='taskSupplierId'>
            <el-select v-model='form.taskSupplierId' size='mini' filterable style='width:100%'
                       placeholder='请选择供应商' value-key='id'>
              <el-option v-for='item in selectedData.supplier' :key='item.id'
                         :label='item.supplierName' :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='拖车牌号：' prop='transportValue'>
            <el-input v-model='form.transportValue' size='mini' placeholder='请输入拖车牌号' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='司机姓名：' prop='taskPeopleName'>
            <el-input v-model='form.taskPeopleName' size='mini' placeholder='请输入司机姓名' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='质损类型：' prop='typeId'>
            <el-select v-model='form.typeId' size='mini' filterable style='width:100%'
                       placeholder='请选择质损类型' value-key='id'>
              <el-option v-for='item in selectedData.type' :key='item.id'
                         :label='item.classaName' :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='质损部位：' prop='detailDesc'>
            <el-input v-model='form.detailDesc' size='mini' placeholder='请输入质损部位（位置）' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='质损部位（位置）：' prop='partIds'>
            <el-select v-model='form.partIds' size='mini' filterable style='width:100%'
                       placeholder='请选择质损部位' value-key='id' multiple>
              <el-option v-for='item in selectedData.position' :key='item.id'
                         :label='item.classaName' :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='质损情况：' prop='situation'>
            <el-input v-model='form.situation' size='mini' placeholder='请输入质损情况' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='维修内容：' prop='maintainContent'>
            <el-input v-model='form.maintainContent' size='mini' placeholder='请输入维修内容' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='质损环节：' prop='link'>
            <el-input v-model='form.link' size='mini' placeholder='请输入质损环节' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='经销商：' prop='distributorId'>
            <el-select v-model='form.distributorId' size='mini' filterable style='width:100%'
                       placeholder='请选择经销商' value-key='id'>
              <el-option v-for='item in selectedData.distributor' :key='item.id'
                         :label='item.shorterName' :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='收车人：' prop='carReceiver'>
            <el-input v-model='form.carReceiver' size='mini' placeholder='请输入收车人' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='联系电话：' prop='contactRmber'>
            <el-input v-model='form.contactRmber' size='mini' type='number' placeholder='请输入联系电话' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='定损金额：' prop='pricingAmount'>
            <el-input v-model='form.pricingAmount' size='mini' type='number'
                      placeholder='请输入定损金额' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='降价金额：' prop='priceReductionAmount'>
            <el-input v-model='form.priceReductionAmount' size='mini' type='number'
                      placeholder='请输入降价金额' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='买断金额：' prop='buyoutAmount'>
            <el-input v-model='form.buyoutAmount' size='mini' type='number' placeholder='请输入买断金额' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发票号码：' prop='invoiceNo'>
            <el-input v-model='form.invoiceNo' size='mini' placeholder='请输入发票号码' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发票金额：' prop='invoicePrice'>
            <el-input v-model='form.invoicePrice' size='mini' type='number' placeholder='请输入发票金额' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发票类型：' prop='invoiceType'>
            <el-input v-model='form.invoiceType' size='mini' placeholder='请输入发票类型' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='开票日期：' prop='invoiceTime'>
            <el-date-picker
              v-model='form.invoiceTime'
              style='width: 100%;'
              size='mini'
              type='date'
              value-format='yyyy-MM-dd'
              placeholder='请选择开票日期'>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='开票单位：' prop='invoiceCompany'>
            <el-input v-model='form.invoiceCompany' size='mini' placeholder='请输入开票单位' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='收到发票日期：' prop='invoiceReceivedDate'>
            <el-date-picker
              v-model='form.invoiceReceivedDate'
              style='width: 100%;'
              size='mini'
              type='date'
              value-format='yyyy-MM-dd'
              placeholder='请选择收到发票日期'>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='是否处罚：' prop='isPunish'>
            <el-radio-group v-model='form.isPunish'>
              <el-radio size='mini' :label='1'>是</el-radio>
              <el-radio size='mini' :label='0'>否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='处罚对象：' prop='punishObj'>
            <el-input v-model='form.punishObj' size='mini' placeholder='请输入处罚对象' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='处罚单位：' prop='punishCompany'>
            <el-input v-model='form.punishCompany' size='mini' placeholder='请输入处罚单位' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='处罚金额：' prop='punishAmount'>
            <el-input v-model='form.punishAmount' size='mini' type='number' placeholder='请输入处罚金额' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='扣款时间：' prop='deductionTime'>
            <el-date-picker
              v-model='form.deductionTime'
              style='width: 100%;'
              size='mini'
              type='date'
              value-format='yyyy-MM-dd'
              placeholder='请选择扣款时间'>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='索赔资料邮寄重庆时间：' prop='mailingTime'>
            <el-date-picker
              v-model='form.mailingTime'
              style='width: 100%;'
              size='mini'
              type='date'
              value-format='yyyy-MM-dd'
              placeholder='请选择索赔资料邮寄重庆时间'>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='付款时间：' prop='paymentTime'>
            <el-date-picker
              v-model='form.paymentTime'
              style='width: 100%;'
              size='mini'
              type='date'
              value-format='yyyy-MM-dd'
              placeholder='请选择付款时间'>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='财务付款金额：' prop='paymentPrice'>
            <el-input v-model='form.paymentPrice' size='mini' type='number'
                      placeholder='请输入财务付款金额' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='向保险公司索赔时间：' prop='claimCompensationDate'>
            <el-date-picker
              v-model='form.claimCompensationDate'
              style='width: 100%;'
              size='mini'
              type='date'
              value-format='yyyy-MM-dd'
              placeholder='请选择向保险公司索赔时间'>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='保险公司回款金额：' prop='receivableAmount'>
            <el-input v-model='form.receivableAmount' size='mini' type='number'
                      placeholder='请输入保险公司回款金额' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='保单号：' prop='policyNumber'>
            <el-input v-model='form.policyNumber' size='mini' placeholder='请输入保单号' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='备注：' prop='remarks'>
            <el-input v-model='form.remarks' size='mini' placeholder='请输入备注' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发票：' prop='invoice'>
            <el-input v-model='form.invoice' size='mini' placeholder='请输入发票' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='向垫付单位回款时间：' prop='collectionTime'>
            <el-date-picker
              v-model='form.collectionTime'
              style='width: 100%;'
              size='mini'
              type='date'
              value-format='yyyy-MM-dd'
              placeholder='请选择向垫付单位回款时间'>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='付款方：' prop='payer'>
            <el-input v-model='form.payer' size='mini' placeholder='请输入付款方' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='责任方：' prop='responsibleParty'>
            <el-input v-model='form.responsibleParty' size='mini' placeholder='请输入责任方' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='责任单位：' prop='responsibleUnit'>
            <el-input v-model='form.responsibleUnit' size='mini' placeholder='请输入责任单位' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='卸船日期：' prop='unloadingTime'>
            <el-date-picker
              v-model='form.unloadingTime'
              style='width: 100%;'
              size='mini'
              type='date'
              value-format='yyyy-MM-dd'
              placeholder='请选择卸船日期'>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='船名：' prop='shipId'>
            <el-select v-model='form.shipId' size='mini' filterable style='width:100%'
                       placeholder='请选择船名' value-key='id'>
              <el-option v-for='item in selectedData.ship' :key='item.id'
                         :label='item.name' :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='有无交接记录：' prop='handoverRecord'>
            <el-input v-model='form.handoverRecord' size='mini' placeholder='请输入有无交接记录' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='编号：' prop='numberBh'>
            <el-input v-model='form.numberBh' size='mini' placeholder='请输入编号' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='二级备注：' prop='remarksTwo'>
            <el-input v-model='form.remarksTwo' size='mini' placeholder='请输入二级备注' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='核对项目：' prop='checkItems'>
            <el-input v-model='form.checkItems' size='mini' placeholder='请输入核对项目' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='保险公司赔付金额：' prop='compensationAmount'>
            <el-input v-model='form.compensationAmount' size='mini' type='number'
                      placeholder='请输入保险公司赔付金额' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='我司承担金额：' prop='commitment'>
            <el-input v-model='form.commitment' size='mini' type='number' placeholder='请输入我司承担金额' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='航向：' >
            <el-input v-model='form.azimuth' size='mini' type='number' placeholder='请输入航向' />
          </el-form-item>
        </el-col>
      </el-row>
      <div class='flex-center-center mt20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import {
    perfectDropDownDataGather,
    perfectQualityLoss,
  } from '@/service/vehiclelog';
  import BatchImport from '@/components/batchImport';

  export default {
    name: 'qualityLossListForm',
    components: {
      BatchImport,
    },
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '新增',
        defaultForm: {},
        form: {},
        rules: {
          taskMode: [
            {
              required: false,
              message: '请选择运输方式',
              trigger: 'blur',
            },
          ],
          taskSupplierId: [
            {
              required: false,
              message: '请选择供应商',
              trigger: 'blur',
            },
          ],
          transportValue: [
            {
              required: false,
              message: '请输入拖车牌号',
              trigger: 'blur',
            },
          ],
          taskPeopleName: [
            {
              required: false,
              message: '请输入司机姓名',
              trigger: 'blur',
            },
          ],
          typeId: [
            {
              required: false,
              message: '请选择质损类型',
              trigger: 'blur',
            },
          ],
          partIds: [
            {
              required: false,
              message: '请选择质损部位',
              trigger: 'blur',
            },
          ],
          detailDesc: [
            {
              required: false,
              message: '请输入质损部位（位置）',
              trigger: 'blur',
            },
          ],
          situation: [
            {
              required: false,
              message: '请输入质损情况',
              trigger: 'blur',
            },
          ],
          maintainContent: [
            {
              required: false,
              message: '请输入维修内容',
              trigger: 'blur',
            },
          ],
          link: [
            {
              required: false,
              message: '请输入质损环节',
              trigger: 'blur',
            },
          ],
          distributorId: [
            {
              required: false,
              message: '请选择经销商',
              trigger: 'blur',
            },
          ],
          carReceiver: [
            {
              required: false,
              message: '请输入收车人',
              trigger: 'blur',
            },
          ],
          contactRmber: [
            {
              required: false,
              message: '请输入联系电话',
              trigger: 'blur',
            },
          ],
          pricingAmount: [
            {
              required: false,
              message: '请输入定损金额',
              trigger: 'blur',
            },
          ],
          priceReductionAmount: [
            {
              required: false,
              message: '请输入降价金额',
              trigger: 'blur',
            },
          ],
          buyoutAmount: [
            {
              required: false,
              message: '请输入买断金额',
              trigger: 'blur',
            },
          ],
          invoiceNo: [
            {
              required: false,
              message: '请输入发票号码',
              trigger: 'blur',
            },
          ],
          invoicePrice: [
            {
              required: false,
              message: '请输入发票金额',
              trigger: 'blur',
            },
          ],
          invoiceType: [
            {
              required: false,
              message: '请输入发票类型',
              trigger: 'blur',
            },
          ],
          invoiceTime: [
            {
              required: false,
              message: '请选择开票日期',
              trigger: 'blur',
            },
          ],
          invoiceCompany: [
            {
              required: false,
              message: '请输入开票单位',
              trigger: 'blur',
            },
          ],
          invoiceReceivedDate: [
            {
              required: false,
              message: '请选择收到发票日期',
              trigger: 'blur',
            },
          ],
          isPunish: [
            {
              required: false,
              message: '请选择是否处罚',
              trigger: 'blur',
            },
          ],
          punishObj: [
            {
              required: false,
              message: '请输入处罚对象',
              trigger: 'blur',
            },
          ],
          punishCompany: [
            {
              required: false,
              message: '请输入处罚单位',
              trigger: 'blur',
            },
          ],
          punishAmount: [
            {
              required: false,
              message: '请输入处罚金额',
              trigger: 'blur',
            },
          ],
          deductionTime: [
            {
              required: false,
              message: '请选择扣款时间',
              trigger: 'blur',
            },
          ],
          mailingTime: [
            {
              required: false,
              message: '请选择索赔资料邮寄重庆时间',
              trigger: 'blur',
            },
          ],
          paymentTime: [
            {
              required: false,
              message: '请选择付款时间',
              trigger: 'blur',
            },
          ],
          paymentPrice: [
            {
              required: false,
              message: '请输入财务付款金额',
              trigger: 'blur',
            },
          ],
          claimCompensationDate: [
            {
              required: false,
              message: '请选择向保险公司索赔时间',
              trigger: 'blur',
            },
          ],
          receivableAmount: [
            {
              required: false,
              message: '请输入保险公司回款金额',
              trigger: 'blur',
            },
          ],
          policyNumber: [
            {
              required: false,
              message: '请输入保单号',
              trigger: 'blur',
            },
          ],
          remarks: [
            {
              required: false,
              message: '请输入备注',
              trigger: 'blur',
            },
          ],
          invoice: [
            {
              required: false,
              message: '请输入发票',
              trigger: 'blur',
            },
          ],
          collectionTime: [
            {
              required: false,
              message: '请选择向垫付单位回款时间',
              trigger: 'blur',
            },
          ],
          payer: [
            {
              required: false,
              message: '请输入付款方',
              trigger: 'blur',
            },
          ],
          responsibleParty: [
            {
              required: false,
              message: '请输入责任方',
              trigger: 'blur',
            },
          ],
          responsibleUnit: [
            {
              required: false,
              message: '请输入责任单位',
              trigger: 'blur',
            },
          ],
          unloadingTime: [
            {
              required: false,
              message: '请选择卸船日期',
              trigger: 'blur',
            },
          ],
          shipId: [
            {
              required: false,
              message: '请选择船名',
              trigger: 'blur',
            },
          ],
          handoverRecord: [
            {
              required: false,
              message: '请输入有无交接记录',
              trigger: 'blur',
            },
          ],
          numberBh: [
            {
              required: false,
              message: '请输入编号',
              trigger: 'blur',
            },
          ],
          remarksTwo: [
            {
              required: false,
              message: '请输入二级备注',
              trigger: 'blur',
            },
          ],
          checkItems: [
            {
              required: false,
              message: '请输入核对项目',
              trigger: 'blur',
            },
          ],
          compensationAmount: [
            {
              required: false,
              message: '请输入保险公司赔付金额',
              trigger: 'blur',
            },
          ],
          commitment: [
            {
              required: false,
              message: '请输入我司承担金额',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        selectedData: {},
      };
    },
    filters: {
      dateFormat(str) {
        if (str) {
          return str.substring(0, 10);
        } else {
          return '无';
        }
      },
    },
    mounted() {
      this.getSelectedData();
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      async getSelectedData() {
        const {
          status,
          message,
          data,
        } = await perfectDropDownDataGather();
        if (status !== 0) return this.$message.warning(message);
        this.selectedData = data;
      },
      dialogOpen(title, row) {
        this.dialogTitle = title;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form = { ...row };
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            const {
              status,
              message,
            } = await perfectQualityLoss({
              ...this.form,
              partId: this.form.partIds ? this.form.partIds.join(',') : '',
            });
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .elForm {
    max-height: 600px;
    overflow: auto;
  }
</style>
